import { render, staticRenderFns } from "./TeamListItem.vue?vue&type=template&id=024b0d36&scoped=true"
import script from "./TeamListItem.vue?vue&type=script&lang=js"
export * from "./TeamListItem.vue?vue&type=script&lang=js"
import style0 from "./TeamListItem.vue?vue&type=style&index=0&id=024b0d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b0d36",
  null
  
)

export default component.exports